import { css } from '@emotion/react'

import { breakpoint, size, width } from '@twistopayments/design-system/styles'

export const modalContent = css`
  margin-top: -${size[16]};
  padding: 0 ${size[32]} ${size[32]} ${size[32]};
  text-align: left;

  ${breakpoint.up('sm')} {
    padding: 0 ${size[40]} ${size[56]} ${size[40]};
  }
`

export const modalWrapper = css`
  max-width: ${width.container.tiny};
`

export const contactRows = css`
  margin-top: ${size[32]};
  display: grid;
  row-gap: ${size[24]};
`

export const contactRow = css`
  display: grid;
  column-gap: ${size[12]};
  grid-template-columns: min-content auto;
  align-items: center;
`
